<template>
    <div class="c-standard-summary">
        <b-card no-body>
            <div slot="header">
                {{caption}}
                <div class="card-header-actions pull-right">
                    <b-button @click="open" type="button" variant="info">{{Core.Definition.getDefinition('Nouveau produit')}}
                    </b-button>
                </div>
            </div>
            <b-card-body>
                <ProductSummary
                        ref="productSummary"
                        :fieldRefs="fieldRefs"
                        @updateTotal="updateTotal"
                        @onMinus="onMinus"
                        @onPlus="onPlus"
                        v-model="dataProducts"></ProductSummary>
                <div v-if="required && !chkState(id)" style="display: block" class="invalid-feedback">
                    <span v-if="invalidFeedbackMessage !== ''">{{invalidFeedbackMessage}}</span>
                    <span v-if="invalidFeedbackMessage === ''">{{Core.Definition.getDefinition('Vous devez sélectionner un produit.')}}</span>
                </div>
                <ModalInstanceSelector
                        :caption="Core.Definition.getDefinition('Liste des produits')"
                        ref="modalInstanceSelector"
                        root="/product/list"
                        v-model="dataProducts"
                        :data="{
                            participant: {
                                firstname: '',
                                lastname: '',
                                birthdate: '',
                                urgencyPhone: '',
                                urgencyContact: '',
                                teamId: '',
                                participantCategoryId: '',
                                tshirtSize: '',
                                tshirtCustomName: '',
                                insuranceNumber: ''
                            },
                            conditional: {
                                eventDateId: null,
                                seasonId: null,
                                leagueId: null,
                                districtId: null
                            },
                            promoCode: {}
                        }"
                        :distinctFunction="isDistinct"
                        :multiple="true"
                        :searchFormStructure="{
                            rows: [
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'id'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'title'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            fields: [
                                {
                                    id: 'id',
                                    type: 'number',
                                    label: Core.Definition.getDefinition('ID'),
                                    value: ''
                                },
                                {
                                    id: 'title',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Titre'),
                                    value: ''
                                }
                            ]
                        }"
                        :searchArgs="[
                            {
                                key: 'type',
                                value: Core.Product.typeStandard
                            }
                        ]"
                        :options="{
                                pagination: true,
                                header: true,
                                responsive: false,
                                striped: true,
                                headerStyle: '1',
                                emptyText: Core.Definition.getDefinition('Aucun produit standard à afficher'),
                                borderVariant: 'white',
                                noBody: true
                         }"
                        :columns="[
                                {
                                    label: Core.Definition.getDefinition('#'),
                                    key: 'id',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Titre'),
                                    key: 'title',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Prix régulier'),
                                    key: 'Readable.regularPrice',
                                    type: 'text',
                                    sortable: true
                                }
                         ]"></ModalInstanceSelector>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    import ProductSummary from './ProductSummary'
    import ModalInstanceSelector from './ModalInstanceSelector'

    export default {
        name: 'ProductStandardSummary',
        components: {
            ProductSummary,
            ModalInstanceSelector,
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            caption: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            updateTotal: {
                type: Function,
                default: function () {
                    return 0
                }
            },
            onChange: {
                type: Function,
                default: function () {
                    return 0
                }
            },
            onMinus: {
                type: Function,
                default: function () {
                    return false
                }
            },
            onPlus: {
                type: Function,
                default: function () {
                    return false
                }
            },
            invalidFeedbackMessage: {
                type: String,
                default: ''
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.dataProducts = val
                },
                deep: true
            },
            dataProducts: {
                handler(val) {
                    this.onChange(val, this.form, this.fieldRefs)
                    this.$emit('input', val)
                },
                deep: true
            }
        },
        mounted() {
            this.dataProducts = Core.Array.newArray(this.value)
        },
        data: () => {
            return {
                Core: window.Core,
                dataProducts: [],
                dataTotal: 0
            }
        },
        methods: {
            open() {
                this.$refs.modalInstanceSelector.open = true
            },
            chkState(val) {
                if (this.form !== undefined && this.form[val] !== undefined) {
                    const field = this.form[val]
                    return !field.$dirty || !field.$invalid
                }
            },
            isDistinct(instance) {
                if (Core.Product.participantModeIsEnabled(instance)) {
                    return true
                }
                return false
            }
        }
    }
</script>
